import { render } from "./HeaderLink.vue?vue&type=template&id=4a807c98"
import script from "./HeaderLink.vue?vue&type=script&lang=js"
export * from "./HeaderLink.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__